import React from 'react';
import PropTypes from 'prop-types';
import { Title } from '@patternfly/react-core';

export const WizardTitle = ({ title, ...props }) => (
  <Title headingLevel="h2" className="wizard-title" {...props}>
    {title}
  </Title>
);

WizardTitle.propTypes = {
  title: PropTypes.string.isRequired,
};
export default WizardTitle;



// WEBPACK FOOTER //
// ./vendor/ruby/2.5.0/gems/foreman_remote_execution-4.5.6/webpack/JobWizard/steps/form/WizardTitle.js